import React from 'react'
import pt from 'prop-types'
import BaseComponent from 'meta/features/base-component'
import cn from 'classnames'
import 'meta/extensions/icons'

class Icon extends BaseComponent {
    render() {
        let {name, spin, className, stack, ...restProps} = this.props
        let _class = cn(`fa fa-${name} fa-stack-${stack}`, {
            'fa-spin': spin
        }, className || {})

        return (
            <span {...restProps} className={_class} />
        )
    }
}

Icon.propTypes = {
    name: pt.string.isRequired,
    spin: pt.bool
}
Icon.defaultProps = {
    spin: false
}

export default Icon
